/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SportografNavigationBar_viewer$ref: FragmentReference;
declare export opaque type SportografNavigationBar_viewer$fragmentType: SportografNavigationBar_viewer$ref;
export type SportografNavigationBar_viewer = {|
  +cart: ?{|
    +lineItems: ?$ReadOnlyArray<?{|
      +id: string
    |}>
  |},
  +$refType: SportografNavigationBar_viewer$ref,
|};
export type SportografNavigationBar_viewer$data = SportografNavigationBar_viewer;
export type SportografNavigationBar_viewer$key = {
  +$data?: SportografNavigationBar_viewer$data,
  +$fragmentRefs: SportografNavigationBar_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SportografNavigationBar_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "cart",
      "storageKey": null,
      "args": null,
      "concreteType": "Cart",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "lineItems",
          "storageKey": null,
          "args": null,
          "concreteType": "LineItem",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "id",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5dd48bc5cb475b1f02c6dda34f28c50d';

module.exports = node;
